export const getStateFromLocalStorage = (key: 'news' | 'sessionBlob19231Q' | 'rowTotalCount' | 'projects' | 'projectsRowTotalCount') => {
    let state;
    const stateAsString = localStorage.getItem(key)
    if (stateAsString !== null) state = JSON.parse(stateAsString)
    return state?.value
};